'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StackMapOverlay = require('./components/StackMapOverlay');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StackMapOverlay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/stackmap/lib/components/stackmap-overlay/index.js
// module id = 1544
// module chunks = 1